import React from "react";
import { Dialog, DialogContent, DialogActions, Button, IconButton } from "@mui/material";
import CloseRounded from "@mui/icons-material/CloseRounded";
import WarningAmberRounded from "@mui/icons-material/WarningAmberRounded";
import EventAvailableRounded from "@mui/icons-material/EventAvailableRounded";
import * as moment from "moment";

/* One dialog for both directions — closing a job and reopening it — so the
   two never drift apart in wording or layout. */
const ConfirmJobStatus = ({ job, onClose, onConfirm }) => {

    if (!job) return null;

    const closing = job.isActive !== false;
    const expired = moment(job.expiredOn).isBefore(new Date(), "day");

    return (
        <Dialog open={Boolean(job)} onClose={onClose} fullWidth maxWidth="xs"
            className={`wh-dialog${closing ? " wh-dialog--danger" : ""}`}
            aria-labelledby="job-status-title">

            <div className="wh-dialog-head">
                <div className="wh-dialog-headings">
                    <h5 id="job-status-title">{closing ? "Close this job?" : "Reopen this job?"}</h5>
                    <p>{job.jobID} · {job.jobTitle}</p>
                </div>
                <IconButton className="wh-dialog-close" onClick={onClose} aria-label="Close">
                    <CloseRounded />
                </IconButton>
            </div>

            <DialogContent>
                {closing ? (
                    <div className="wh-warn">
                        <WarningAmberRounded />
                        <p>
                            It will show as Inactive and stop being offered to recruiters. Candidates
                            already in the pipeline are not affected, and you can reopen it at any time.
                        </p>
                    </div>
                ) : (
                    <div className="wh-note">
                        <EventAvailableRounded />
                        <p>
                            It will show as Active again{expired
                                ? `, but its expiry date of ${moment(job.expiredOn).format("DD MMM YYYY")} has already passed — edit the job to extend it.`
                                : `, open until ${moment(job.expiredOn).format("DD MMM YYYY")}.`}
                        </p>
                    </div>
                )}
            </DialogContent>

            <DialogActions>
                <Button variant="contained" color="inherit" onClick={onClose}>Cancel</Button>
                <Button variant="contained" color={closing ? "error" : "primary"} onClick={onConfirm}>
                    {closing ? "Close job" : "Reopen job"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmJobStatus;
